<template>
    <div class="box">
    <div class="box_left">
     
                   <div class="block">
    <span class="demonstration">请选择</span>
      <el-date-picker
                        v-model="value1"
                        type="daterange"
                          :default-time="['00:00:00', '23:59:59']"
                         format="yyyy 年 MM 月 dd 日"
                        value-format="timestamp"
                        range-separator="至"
                        start-placeholder="开始日期"
                        @change="changebar"
                        end-placeholder="结束日期">
                        </el-date-picker>
  </div>
                      
                   <p>启动页</p>
              <div id="chart1" class="bar"></div>
    </div>
      <div class="littleApp">
        <div class="righterchets">
               <div class="block">
    <span class="demonstration">请选择</span>
        <el-date-picker
                        v-model="value2"
                        type="daterange"
                          :default-time="['00:00:00', '23:59:59']"
                         format="yyyy 年 MM 月 dd 日"
                         @change="changeMini"
                        value-format="timestamp"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                        </el-date-picker>
  </div>
             <p>小程序</p>
                    
                     
                   
           <div id="chart2" class="bar2"/>
                           <div class="block">
    <span class="demonstration">请选择</span>
       
                        <el-date-picker
                        v-model="value3"
                          :default-time="['00:00:00', '23:59:59']"
                        type="daterange"
                         format="yyyy 年 MM 月 dd 日"
                         @change="changebarPv"
                        value-format="timestamp"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                        </el-date-picker>
  </div>
  <p>停留时长</p>
                   
            <div id="chart3" class="bar2"/>
        </div>
      </div>
    </div>
</template>
<script>
import testServer from '@/api/management.js'
import moment from 'moment'

const mount  =  (params) =>{
  return  moment(params).format('YYYY-MM-DD')
}
export default {
    data () {
        return {
            days:'',
            value1:[],
            value2:[],
            value3:[],
            startupPageClickList:{
                value:[],
                time:[]
            }
        }
    },
    methods: {
         dateDiff(startDateString, endDateString){  
            var separator = "-"; //日期分隔符  
            var startDates = startDateString.split(separator);  
            var endDates = endDateString.split(separator);  
            var startDate = new Date(startDates[0], startDates[1]-1, startDates[2]);  
            var endDate = new Date(endDates[0], endDates[1]-1, endDates[2]);  
            this.days = parseInt(Math.abs(endDate - startDate ) / 1000 / 60 / 60 /24)+1;//把相差的毫秒数转换为天数   
        },
        changebar(){
            let star = mount( this.value1[0])
            let end = mount(this.value1[1])
            this.dateDiff(star,end)
            console.log(this.days)
            
            testServer.echeo.arr({endTime:this.value1[1],limit:this.days}).then(res =>{
            console.log(res.data.data.startupPageClickList)
            // res.data.data.startupPageClickList.forEach(item => {
            //     this.startupPageClickList.value.push(item.value)
            //     this.startupPageClickList.time.push(mount(item.time))
            // });
           console.log('dadada', res.data.data.startupPageClickList[5])
            this.$chart.line1('chart1',res.data.data);
        })
        },
        changeMini(){
               let star = mount( this.value2[0])
                let end = mount(this.value2[1])
                this.dateDiff(star,end)
                testServer.echeo.arr({endTime:this.value2[1],limit:this.days}).then(res =>{
            console.log(res.data.data.startupPageClickList)
            // res.data.data.startupPageClickList.forEach(item => {
            //     this.startupPageClickList.value.push(item.value)
            //     this.startupPageClickList.time.push(mount(item.time))
            // });
           console.log('dadada', res.data.data.startupPageClickList[5])
          
           
             this.$chart.line2('chart2',res.data.data);
            
            console.log(res.data.data) 
        })
        },
        changebarPv(){
              let star = mount( this.value3[0])
                let end = mount(this.value3[1])
                  this.dateDiff(star,end)
              testServer.echeo.arr({endTime:this.value3[1],limit:this.days}).then(res =>{
            console.log(res.data.data.startupPageClickList)
            // res.data.data.startupPageClickList.forEach(item => {
            //     this.startupPageClickList.value.push(item.value)
            //     this.startupPageClickList.time.push(mount(item.time))
            // });
           console.log('dadada', res.data.data.startupPageClickList[5])
          
             this.$chart.line3('chart3',res.data.data);
            console.log(res.data.data) 
        })
        }

    },
    mounted () {
        let timestamp = (new Date()).getTime()
        testServer.echeo.arr({endTime:timestamp}).then(res =>{
            console.log(res.data.data.startupPageClickList)
            // res.data.data.startupPageClickList.forEach(item => {
            //     this.startupPageClickList.value.push(item.value)
            //     this.startupPageClickList.time.push(mount(item.time))
            // });
           console.log('dadada', res.data.data.startupPageClickList[5])
          
            this.$chart.line1('chart1',res.data.data);
             this.$chart.line2('chart2',res.data.data);
             this.$chart.line3('chart3',res.data.data);
            console.log(res.data.data) 
        })
            
         
            // this.$chart.line1('chart2',this.startupPageClickList);
            //   this.$chart.line1('chart3',this.startupPageClickList);
    }
}
</script>

<style lang="scss" scoped>
.box{
    display: flex;
    .box_left{
        margin-top: 150px;
    }
      .bar {
          width: 1000px;
          height: 300px;
        }
        @media screen and (max-width: 1440px) {
    .bar {
       width: 600px;
          height: 300px;
    }
    .bar2{
          width: 400px;
          height: 200px;
        
      }
}
      .bar2{
          margin-bottom: 20px;
           margin-right: 20px;
          width: 800px;
          height: 300px;
         
      }
    .littleApp{
       
        border-left: 2px solid #909399;
        margin-right: auto;
        display: flex;
        flex-direction: column;
        .righterchets{
            margin-left: 20px;
        }
    }
    .block{
        display: flex;
        align-items: center;
        span{
            margin-right: 10px;
        }
    }
}
   
</style>
